import ApiService from "../util/api.service";
import utilService from "../util/utils.service";
import { SERVICE_CONFIG_URLS } from "./config";

const AccessService = {
    getCategoryList,
    deleteContent,
    addAccessContent,
    getAccessListing,
    changeAccessOrder,
    updateAccessContent,
    getAccessById
}; 

async function getCategoryList() {
    const response = await ApiService.get(SERVICE_CONFIG_URLS.ACCESS.CATEGORY_LIST);
    return response;
}

async function deleteContent(id) {
    const url = utilService.createDynamicUrl(SERVICE_CONFIG_URLS.ACCESS.DELETE_CONTENT, { id });
    const response = await ApiService.delete(url);
    return response;
}

async function changeAccessOrder(payload) {
    const response = await ApiService.put(SERVICE_CONFIG_URLS.ACCESS.ACCESS_ORDER, payload);
    return response;
}

async function updateAccessContent({ id, ...payload }) {
    const url = utilService.createDynamicUrl(SERVICE_CONFIG_URLS.ACCESS.UPDATE_CONTENT, { id });
    const response = await ApiService.put(url, payload);
    return response;
}

async function addAccessContent(payload) {
    const response = await ApiService.post(SERVICE_CONFIG_URLS.ACCESS.ADD_CONTENT, payload);
    return response;
}
async function getAccessListing({ id, payload }) {
    const url = utilService.createDynamicUrl(SERVICE_CONFIG_URLS.ACCESS.ACCESS_LISTING, { id });
    const response = await ApiService.get(url, payload);
    return response;
}

async function getAccessById(id) {
    const url = utilService.createDynamicUrl(SERVICE_CONFIG_URLS.ACCESS.ACCESS_DETAILS, { id });
    const response = await ApiService.get(url);
    return response;
}
export default AccessService;
